import { useEffect, useState } from 'react';
import { canUseDOM } from 'exenv';

type WindowSizes = {
  width: number;
  height: number;
  ratio: number;
};

export const useWindowSizes = (): WindowSizes => {
  const [sizes, setSizes] = useState<WindowSizes>({
    width: canUseDOM ? window.innerWidth : 0,
    height: canUseDOM ? window.innerHeight : 0,
    ratio: canUseDOM ? window.innerWidth / window.innerHeight : 0
  });

  useEffect(() => {
    const handleResize = () => {
      setSizes({
        width: window.innerWidth,
        height: window.innerHeight,
        ratio: window.innerWidth / window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return sizes;
};
